import { syncBack } from "@/shared/http"
import { verifyTurnstileToken } from "@/shared/http/turnstile"
import { useTurnstile } from "@/shared/components/Turnstile/use-turnstile"
import { SyncBackBody } from "@/shared/types/lead-api-types"
import { useMutation } from "@tanstack/react-query"
import { TrackJS } from "trackjs-nextjs"

export const useSyncBack = () => {
  const { getToken, resetToken } = useTurnstile()

  return useMutation({
    mutationKey: ["sync-back"],
    mutationFn: async (ctx: SyncBackBody) => {
      await verifyTurnstileToken(getToken(), resetToken)
      const res = await syncBack(ctx)
      return res
    },
    onError: (error) => {
      TrackJS.track(error as string)
    },
  })
}
